let sessionIdCounter = 0;
export class CpdlcSession {
    authority;
    callsign;
    departure;
    destination;
    constructor(authority, callsign, departure, destination) {
        this.authority = authority;
        this.callsign = callsign;
        this.departure = departure;
        this.destination = destination;
    }
    id = sessionIdCounter++;
    dialogMap = {};
    start = null;
    end = null;
    lastUpdatedAt = Date.now();
    sessionState = null;
}
//# sourceMappingURL=cpdlcSession.js.map